import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import ArrowDown from '../../../assets/icons/arrow-down.svg?react';
import { Button } from '../../buttons';
import { useAutoScroll } from './hooks/useAutoScroll';

interface ChatMessageListProps extends React.HTMLAttributes<HTMLDivElement> {
  smooth?: boolean;
}

const ChatMessageList = React.forwardRef<HTMLDivElement, ChatMessageListProps>(({ className, children, smooth = false, ...props }) => {
  const { scrollRef, isAtBottom, scrollToBottom, disableAutoScroll } = useAutoScroll({
    smooth,
    content: children,
  });

  return (
    <div className='relative'>
      <div
        className={twMerge(`flex flex-col gap-y-6 min-h-[45dvh] max-h-[55dvh] overflow-y-auto scroll-smooth`, className)}
        ref={scrollRef}
        onWheel={disableAutoScroll}
        onTouchMove={disableAutoScroll}
        {...props}
      >
        {children}
      </div>

      {!isAtBottom && (
        <Button
          onClick={() => {
            scrollToBottom();
          }}
          variant='light'
          className='absolute bottom-2 left-1/2 transform -translate-x-1/2 rounded-full'
          aria-label='Scroll to bottom'
        >
          <ArrowDown className='size-4' />
        </Button>
      )}
    </div>
  );
});

ChatMessageList.displayName = 'ChatMessageList';

export { ChatMessageList };
